const RichRelevanceBaseInstrumentationController = require('./rr-base-instrumentation-controller');

class RichRelevanceGenericInstrumentationController extends RichRelevanceBaseInstrumentationController {

    constructor($scope, $window, featureService, richRelevanceService) {
        super($scope, $window, featureService, richRelevanceService);
        this.richRelevanceService = richRelevanceService;
        this.$window = $window;
    }

    sendInstrumentation() {
        this.richRelevanceService.getInformation()
            .then(() => {
                this.$window.R3_GENERIC = new this.$window.r3_generic(); // eslint-disable-line new-cap
                this.addPlacementTypesIfEnabled();
                this.$window.rr_flush_onload();
                this.$window.r3();
            });
    }
}

const richRelevanceGenericInstrumentationComponentDefinition = {
    controller: ['$scope', '$window', 'FeatureService', 'RichRelevanceService', RichRelevanceGenericInstrumentationController],
    bindings: {
        // page group and placement ids for base controller.
        pageGroup: '@',
        placementIds: '@',
    },
};

module.exports = {
    RichRelevanceGenericInstrumentationController,
    richRelevanceGenericInstrumentationComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/shop/richrelevance/instrumentation/rr-generic-instrumentation.component.js